import { coreClient } from '@/api/coreclient'
import type { TemplateAIAttributes } from 'common'

export default {
  async getAllReportTemplates(): Promise<Pick<TemplateAIAttributes, 'id' | 'name' | 'tags'>[]> {
    const client = await coreClient()
    const templates = await client.aiReports.listReportTemplates()
    templates.sort((a, b) => a.name.localeCompare(b.name))
    return templates
  },
  async generateReport(
    templateId: number,
    payload: unknown,
    reportName?: string,
    useDevFile: boolean = false,
    hiddenTabs?: string,
    deletedTabs?: string,
    attachments?: { data: string; mimeType: string }[]
  ): Promise<string> {
    const client = await coreClient()
    const requestBody = { payload, reportName, attachments }
    return client.aiReports.generateReport(
      templateId,
      requestBody,
      useDevFile,
      hiddenTabs,
      deletedTabs
    )
  },
  async generateCustomReport(
    sections: (string | { type: 'image'; data: string; mimeType: string })[],
    payload: unknown,
    reportName: string,
    useDevFile: boolean = false,
    hiddenTabs?: string,
    deletedTabs?: string,
    attachments?: { data: string; mimeType: string }[]
  ): Promise<string> {
    const client = await coreClient()
    const requestBody = { sections, payload, reportName, attachments }
    return client.aiReports.generateReportCustom(requestBody, useDevFile, hiddenTabs, deletedTabs)
  }
}
